module.exports = __webpack_public_path__ + "fonts/HarmonyOS_Sans_SC_Thin.501d49f4.ttf";